export default {
    list: {
        title: "Payments Histories",
        name: 'paymentsHistories',
        icone: "history",
        class: "flex-1 mt-1 px-3 items-center",
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: false,
                name: "Actions",
                buttons: [{
                    text: "",
                    icon: "",
                    link: '',
                    color: 'primary'
                }],
            }
        },
        columns: [{
                name: "Date",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "User",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "user",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold",
                                icone: "contacts"
                            }]
                        }]
                    }],
                }, ]
            },
            // {
            //     name: "Comment",
            //     elements: [{
            //         items: [{
            //             class: "",
            //             name: "comment",
            //             type: "text",

            //         }, ],
            //     }, ]
            // },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        options: (item) => {
                            switch (item) {
                                case 'pending':
                                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                                    break;
                                case 'processed':
                                    return "color:rgb(106 71 9); border-color: rgb(106 71 9);"
                                    break;
                               
                            }
                        },
                    }],
                }, ]
            },
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [{
                icone: "delete",
                color: "danger",
                role: true,
                key: 'delete',
                tooltip: "Delete",
            }],
        },

    },
}
